<nav
  id="sidebar"
  class="sidebar"
  [ngClass]="{ 'sidebar-bg': hasBackgroundImage() }"
>
  <div class="sidebar-content">
    <perfect-scrollbar>
      <div class="sidebar-header">
        <a href="#">Admin</a>
      </div>

      <!-- <div class="sidebar-profile">
        <div class="user-pic">
          <img
            class="img-responsive img-rounded"
            src="assets/img/user.jpg"
            alt="User picture"
          />
        </div>
        <div class="user-info">
          <span class="user-name"
            >Jhon
            <strong>Smith</strong>
          </span>
          <span class="user-role">Administrator</span>
          <span class="user-status">
            <i class="fa fa-circle"></i>
            <span>Online</span>
          </span>
        </div>
      </div> -->
      <!-- <div class="sidebar-search">
        <div>
          <div class="input-group">
            <input
              type="text"
              class="form-control search-menu"
              placeholder="Search..."
            />
            <div class="input-group-append">
              <span class="input-group-text">
                <i class="fa fa-search" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>
      </div> -->
      <div class="sidebar-menu">
        <ul class="root-menu">
          <li
            *ngFor="let menu of menu"
            [ngClass]="{
              active: menu.active,
              'sidebar-dropdown': menu.type === 'dropdown',
              'header-menu': menu.type === 'header'
            }"
          >
            <span *ngIf="menu.type === 'header'">{{ menu.title }}</span>
            <a
              *ngIf="menu.type === 'dropdown'"
              class="pointer"
              (click)="toggle(menu)"
            >
              <i class="{{ menu.icon }}"></i>
              <span>{{ menu.title }}</span>
              <span
                *ngIf="menu.badge"
                class="badge badge-pill"
                [ngClass]="menu.badge.class"
                >{{ menu.badge.text }}</span
              >
            </a>
            <a
              *ngIf="menu.type === 'simple'"
              [routerLink]="[menu.route]"
              (click)="toggle(menu)"
            >
              <i class="{{ menu.icon }}"></i>
              <span>{{ menu.title }}</span>
              <span
                *ngIf="menu.badge"
                class="badge badge-pill"
                [ngClass]="menu.badge.class"
                >{{ menu.badge.text }}</span
              >
            </a>
            <div
              *ngIf="menu.type === 'dropdown'"
              class="sidebar-submenu"
              [@slide]="getState(menu)"
            >
              <ul>
                <li *ngFor="let submenu of menu.submenus">
                  <a [routerLink]="[submenu.route]">
                    {{ submenu.title }}
                    <span
                      *ngIf="submenu.badge"
                      class="badge badge-pill"
                      [ngClass]="submenu.badge.class"
                      >{{ submenu.badge.text }}</span
                    >
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </perfect-scrollbar>
  </div>
  <!-- <div class="sidebar-footer">
    <div class="dropdown" dropdown>
      <a href="#" dropdownToggle>
        <i class="fa fa-bell"></i>
        <span class="badge badge-pill badge-warning notification">5</span>
      </a>
      <div class="dropdown-menu notifications" *dropdownMenu>
        <div class="notifications-header">
          <i class="fa fa-bell"></i>
          Notifications
        </div>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#">
          <div class="notification-content">
            <div class="icon">
              <i class="fas fa-check text-success border border-success"></i>
            </div>
            <div class="content">
              <div class="notification-detail">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. In
                totam explicabo
              </div>
              <div class="notification-time">6 minutes ago</div>
            </div>
          </div>
        </a>
        <a class="dropdown-item" href="#">
          <div class="notification-content">
            <div class="icon">
              <i class="fas fa-exclamation text-info border border-info"></i>
            </div>
            <div class="content">
              <div class="notification-detail">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. In
                totam explicabo
              </div>
              <div class="notification-time">Today</div>
            </div>
          </div>
        </a>
        <a class="dropdown-item" href="#">
          <div class="notification-content">
            <div class="icon">
              <i
                class="
                  fas
                  fa-exclamation-triangle
                  text-warning
                  border border-warning
                "
              ></i>
            </div>
            <div class="content">
              <div class="notification-detail">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. In
                totam explicabo
              </div>
              <div class="notification-time">Yesterday</div>
            </div>
          </div>
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item text-center" href="#">View all notifications</a>
      </div>
    </div>
    <div class="dropdown" dropdown>
      <a href="#" dropdownToggle>
        <i class="fa fa-envelope"></i>
        <span class="badge badge-pill badge-success notification">7</span>
      </a>
      <div class="dropdown-menu messages" *dropdownMenu>
        <div class="messages-header">
          <i class="fa fa-envelope"></i>
          Messages
        </div>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item" href="#">
          <div class="message-content">
            <div class="pic">
              <img src="assets/img/user.jpg" alt="" />
            </div>
            <div class="content">
              <div class="message-title">
                <strong> Jhon doe</strong>
              </div>
              <div class="message-detail">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. In
                totam explicabo
              </div>
            </div>
          </div>
        </a>
        <a class="dropdown-item" href="#">
          <div class="message-content">
            <div class="pic">
              <img src="assets/img/user.jpg" alt="" />
            </div>
            <div class="content">
              <div class="message-title">
                <strong> Jhon doe</strong>
              </div>
              <div class="message-detail">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. In
                totam explicabo
              </div>
            </div>
          </div>
        </a>
        <a class="dropdown-item" href="#">
          <div class="message-content">
            <div class="pic">
              <img src="assets/img/user.jpg" alt="" />
            </div>
            <div class="content">
              <div class="message-title">
                <strong> Jhon doe</strong>
              </div>
              <div class="message-detail">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. In
                totam explicabo
              </div>
            </div>
          </div>
        </a>
        <div class="dropdown-divider"></div>
        <a class="dropdown-item text-center" href="#">View all messages</a>
      </div>
    </div>
    <div class="dropdown" dropdown>
      <a href="#" dropdownToggle>
        <i class="fa fa-cog"></i>
        <span class="badge-sonar"></span>
      </a>
      <div class="dropdown-menu" *dropdownMenu>
        <a class="dropdown-item" href="#">My profile</a>
        <a class="dropdown-item" href="#">Help</a>
        <a class="dropdown-item" href="#">Setting</a>
      </div>
    </div>
    <div>
      <a href="#">
        <i class="fa fa-power-off"></i>
      </a>
    </div>
  </div> -->
</nav>
